<form novalidate>
    <mat-card style="width: 100%; text-align: center;">
        <mat-card-header style="flex-direction: column;">
            <mat-card-title >Acesso negado!</mat-card-title>
        </mat-card-header>

        <mat-card-content>
            <div>
                <button type="button" mat-raised-button (click)="voltar()" color="primary">
                    <mat-icon>undo</mat-icon> Voltar
                </button>
            </div>
        </mat-card-content>
    </mat-card>
</form>
